/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

  document.querySelectorAll('.search-input').forEach(function(element) {
      element.addEventListener('focus', function() {
          this.parentElement.parentElement.querySelector('.predictive-search-popular').style.display = 'block';
      });
  });

  /* HOVER IMAGE FOR sections/section-collections-list.liquid */
  document.querySelectorAll(".collection-item__bg").forEach(function(element) {
    element.addEventListener("mouseenter", function() {
      const hoverSrc = this.getAttribute("data-hover-image");
      if (hoverSrc) {
        const img = this.querySelector("img");
        const originalSrc = img.getAttribute("srcset");
        img.setAttribute("src", hoverSrc);
        img.setAttribute("srcset", hoverSrc);
        this.setAttribute("data-original-image", originalSrc);
      }
    });  
    element.addEventListener("mouseleave", function() {
      const originalSrc = this.getAttribute("data-original-image");
      if (originalSrc) {
        const img = this.querySelector("img");
        img.setAttribute("srcset", originalSrc);
        img.setAttribute("src", originalSrc);
      }
    });
  });  
 
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


